import Accordion from 'react-bootstrap/Accordion'
import useI18n from 'src/hooks/use_i18n'
import styles from './index.module.scss'

interface FaqItem {
  _question: string
  _answer: string
}

export default function Faq({ faqList }: { faqList: FaqItem[] }) {
  const { $t } = useI18n()

  return (
    <section className={styles.faqContainer} itemScope itemType="https://schema.org/FAQPage">
      <h2>{$t('ResWwwPlatform.global.__PlatformFaqTitle')}</h2>
      <Accordion className={styles.faqMain}>
        {faqList.map((item, index) => {
          const id = `collapse_${index}`
          return (
            <Accordion.Item
              eventKey={id}
              key={id}
              itemProp="mainEntity"
              itemScope
              itemType="https://schema.org/Question"
            >
              <Accordion.Header as="h3">
                <span itemProp="name">{item._question}</span>
              </Accordion.Header>
              <Accordion.Body as="p" itemScope itemType="https://schema.org/Answer" itemProp="acceptedAnswer">
                <span
                  itemProp="text"
                  dangerouslySetInnerHTML={{
                    __html: item._answer
                  }}
                ></span>
              </Accordion.Body>
            </Accordion.Item>
          )
        })}
      </Accordion>
    </section>
  )
}
